var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgServerIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15318_1343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 57
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H56V56.5H0V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15318_1343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.32566 1.59369H39.0369C40.2645 1.59369 41.2689 2.59798 41.2689 3.8256V12.7534C41.2689 13.9811 40.2645 14.9854 39.0369 14.9854H3.32566C2.09803 14.9854 1.09375 13.9811 1.09375 12.7534V3.8256C1.09375 2.59798 2.09803 1.59369 3.32566 1.59369Z",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32566 1.59369H39.0369C40.2645 1.59369 41.2689 2.59798 41.2689 3.8256V12.7534C41.2689 13.9811 40.2645 14.9854 39.0369 14.9854H3.32566C2.09803 14.9854 1.09375 13.9811 1.09375 12.7534V3.8256C1.09375 2.59798 2.09803 1.59369 3.32566 1.59369Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 10.5215H36.805",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 10.5215H36.805",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 6.05762H5.5588",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 6.05762H5.5588",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5791 6.05762H10.5803",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5791 6.05762H10.5803",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 6.05762H15.6027",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 6.05762H15.6027",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32566 19.4497H39.0369C40.2645 19.4497 41.2689 20.4539 41.2689 21.6816V30.6094C41.2689 31.8369 40.2645 32.8413 39.0369 32.8413H3.32566C2.09803 32.8413 1.09375 31.8369 1.09375 30.6094V21.6816C1.09375 20.4539 2.09803 19.4497 3.32566 19.4497Z",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32566 19.4497H39.0369C40.2645 19.4497 41.2689 20.4539 41.2689 21.6816V30.6094C41.2689 31.8369 40.2645 32.8413 39.0369 32.8413H3.32566C2.09803 32.8413 1.09375 31.8369 1.09375 30.6094V21.6816C1.09375 20.4539 2.09803 19.4497 3.32566 19.4497Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 28.3774H36.805",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 28.3774H36.805",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 23.9131H5.5588",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 23.9131H5.5588",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5791 23.9131H10.5803",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5791 23.9131H10.5803",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 23.9131H15.6027",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 23.9131H15.6027",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7745 50.6968H3.32576C2.09825 50.6968 1.09375 49.6924 1.09375 48.4648V39.537C1.09375 38.3094 2.09814 37.3051 3.32576 37.3051H36.8617",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7745 50.6968H3.32576C2.09825 50.6968 1.09375 49.6924 1.09375 48.4648V39.537C1.09375 38.3094 2.09814 37.3051 3.32576 37.3051H36.8617",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 46.2329H34.2715",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 46.2329H34.2715",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 41.769H5.5588",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55762 41.769H5.5588",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5791 41.769H10.5803",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5791 41.769H10.5803",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 41.769H15.6027",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 41.769H15.6027",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32617 14.9853V19.4492",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32617 14.9853V19.4492",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0371 14.9853V19.4492",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0371 14.9853V19.4492",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32617 32.8413V37.3052",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32617 32.8413V37.3052",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0371 32.8409V35.9136",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0371 32.8409V35.9136",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2821 56.5C50.736 56.5 55.9999 51.2362 55.9999 44.7823C55.9999 38.3283 50.736 33.0645 44.2821 33.0645C37.8282 33.0645 32.5645 38.3283 32.5645 44.7823C32.5645 51.2362 37.8282 56.5 44.2821 56.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2821 56.5C50.736 56.5 55.9999 51.2362 55.9999 44.7823C55.9999 38.3283 50.736 33.0645 44.2821 33.0645C37.8282 33.0645 32.5645 38.3283 32.5645 44.7823C32.5645 51.2362 37.8282 56.5 44.2821 56.5Z",
    fill: "#B60202",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6304 41.4345L40.9346 48.1304",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6304 41.4345L40.9346 48.1304",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9346 41.4345L47.6304 48.1304",
    stroke: "#B60202",
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9346 41.4345L47.6304 48.1304",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2.1875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgServerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ServerIcon.9bba5957f42be5a03c2be65ce66f87da.svg";